import { VariableType } from 'json-to-graphql-query';

import { Person } from '@/interfaces/person';
import { EntityResource } from './entity.resource';

/**
 * Resource osób
 *
 * @export
 * @class PersonResource
 * @extends {EntityResource<Person>}
 */
export class PersonResource extends EntityResource<Person> {
  public getFields = {
    id: true,
    firstName: true,
    lastName: true,
    pesel: true,
    address: true
  };

  public listFields = {
    id: true,
    firstName: true,
    lastName: true,
    pesel: true,
    address: true,
    structureUid: true
  };

  public listArgs = { filters: new VariableType('filters') };

  public listVariables = { filters: 'PersonFilters!' };

  constructor() {
    super({ entityName: 'person' });
  }
}

export const personResource = new PersonResource();
